import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { PlatformMenuFilter } from "./PlatformMenuFilter";
import { PlatformMenuList } from "./PlatformMenuList";
import { CreateMenuItemDialog } from "./CreateMenuItemDialog";
import { EditMenuItemDialog } from "./EditMenuItemDialog";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

export const PlatformMenu: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    tab,
    id: menuItemId,
    index: menuItemIndex,
  } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string; index?: string };

  const handleCreate = (index?: number) => {
    searchParams.set("tab", "create");
    if (index) {
      searchParams.set("index", String(index));
    } else {
      searchParams.delete("index");
    }
    setSearchParams(searchParams);
  };

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCloseCreateDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("index");
    setSearchParams(searchParams);
  };

  const handleCloseEditDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <PlatformMenuFilter onCreateItem={handleCreate} />
        <PlatformMenuList onCreateItem={handleCreate} onEditItem={handleEdit} />
      </Stack>

      <CreateMenuItemDialog
        open={tab === "create"}
        index={menuItemIndex ? Number.parseInt(menuItemIndex, 10) : undefined}
        onClose={handleCloseCreateDialog}
      />

      <EditMenuItemDialog
        open={tab === "edit"}
        menuItemId={menuItemId || ""}
        onClose={handleCloseEditDialog}
      />
    </FilterProvider>
  );
};
